interface JWTPayload {
  exp: number;
  iat: number;
  dat?: {
    account_id: number;
    user_id: number;
    slug?: string;
    back_to_url?: string;
  };
}

const TOKEN_BUFFER_MS = 30 * 1000;

let inMemoryToken: string | null = null;

const isTokenExpired = (token: string | null): boolean => {
  if (!token) return true;

  try {
    const payload: JWTPayload = JSON.parse(atob(token.split(".")[1]));
    const expiresAt = payload.exp * 1000;
    return Date.now() >= expiresAt - TOKEN_BUFFER_MS;
  } catch {
    return true;
  }
};

const getToken = (): string | null => inMemoryToken;

const setToken = (token: string): void => {
  inMemoryToken = token;
};

const clearToken = (): void => {
  inMemoryToken = null;
};

const hasValidToken = (): boolean => !isTokenExpired(inMemoryToken);

export const tokenStore = Object.freeze({
  getToken,
  setToken,
  clearToken,
  isTokenExpired,
  hasValidToken,
});
